module.exports = require("vue-meta");